var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageFund(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 18.9989H15.75C18.0674 18.9936 19.3075 18.9366 20.2223 18.3253C20.659 18.0335 21.034 17.6585 21.3259 17.2217C22 16.2128 22 14.8084 22 11.9995C22 9.19053 22 7.78607 21.3259 6.77717C21.034 6.34041 20.659 5.96541 20.2223 5.67357C19.3075 5.06232 18.0674 5.00532 15.75 5H14.25V8.99902H15C16.6569 8.99902 18 10.3422 18 11.999C18 13.6559 16.6569 14.999 15 14.999H14.25V18.9989Z",
    fill: "#1C274C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 18.9989V14.999H9C7.34315 14.999 6 13.6559 6 11.999C6 10.3422 7.34315 8.99902 9 8.99902H9.75V5H8.25C5.93257 5.00532 4.69253 5.06232 3.77772 5.67358C3.34096 5.96541 2.96596 6.34041 2.67412 6.77717C2 7.78607 2 9.19053 2 11.9995C2 14.8084 2 16.2128 2.67412 17.2217C2.96596 17.6585 3.34096 18.0335 3.77772 18.3253C4.69253 18.9366 5.93258 18.9936 8.25 18.9989H9.75Z",
    fill: "#1C274C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.75 19L14.25 19V5H9.75V19Z",
    fill: "#1C274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageFund);
export default __webpack_public_path__ + "static/media/manage-fund.f818f8363af2d4b883fc98fd36725d11.svg";
export { ForwardRef as ReactComponent };